export const OrderOrigin = {
  Local: 'Local',
  Dispatch: 'Dispatch',
  External: 'External',
};
